// Should it be class?

import {JS_DATE_FORMAT} from "./utils";
import {model as config, moment} from "./ext-refs";
import uuid from "uuid/v4";
const STAGED_PM_CATEGORY_SUFFIX = '_IVR';

/**
 * @param data
 * @param config
 */
function createNewPayment(data, config) {
    data.nginxJwtToken = data.nginxJwtToken || config.nginxJwtToken;
    data.xotpJwtToken = data.xotpJwtToken || config.oppJwt;
    const firstPaymentType = config.paymentConfig.paymentTypes[0];
    const isOnePt = config.paymentConfig.paymentTypes.length === 1;
    data.nextNumber = (data.nextNumber || 0);
    const paymentIndex = ++data.nextNumber;
    let payment = {
            externalData: "",
        header: {
            internalPaymentTypeCode: isOnePt ? firstPaymentType.code : "",
            internalPaymentAmount: 0,
            // whenever the payment amount changes, we update the convenience fee for this payment
            set paymentAmount(val) {
                this.internalPaymentAmount = val;
                updateConvenienceFee(data, config, paymentIndex, this.paymentTypeId, this.paymentAmount);
            },
            get paymentAmount() {
                return this.internalPaymentAmount;
            },
            // whenever the payment code changes, we update the payment type id for this payment
            set paymentTypeCode(val) {
                this.internalPaymentTypeCode = val;
                let paymentTypes = config.paymentConfig.paymentTypes;
                for (let i = 0; i < paymentTypes.length; i++) {
                    if (paymentTypes[i].code === val) {
                        this.paymentTypeId = paymentTypes[i].id;
                        break;
                    }
                }
            },
            get paymentTypeCode() {
                return this.internalPaymentTypeCode;
            },
            // whenever the payment type id changes, we update the convenience fee for this payment
            set paymentTypeId(val) {
                this.internalPaymentTypeId = val;
                updateConvenienceFee(data, config, paymentIndex, this.paymentTypeId, this.paymentAmount);
            },
            get paymentTypeId() {
                return this.internalPaymentTypeId;
            }
        },
        // index is used for contructing the react component key for each payment
        // e.g. AccountInfo-1, PaymentInfo-1, AccountInfo-2, PaymentInfo-2, etc.
        // index is also used for identifying a payment for removal therefore
        // it has to be unique for a payment
        index: paymentIndex,
        users: [] // registered users for this account
    };
    return payment;
}

/**
 * Partially set payment fields from itok
 * @param data
 * @param config
 */
function prepopulatePartialPayment(data, config) {
    const prepopulatedData = config.prepopulatedData;
    if(!prepopulatedData || !prepopulatedData.accounts){
        let paymentAmount;
        const {paymentTypeCode, accountNumber, authToken1, authToken2, authToken3, externalReferenceNumber, strPaymentAmount, step} = config.prepopulatedData || {};
        if(strPaymentAmount){
            paymentAmount = parseFloat(strPaymentAmount);
        }
        const isOnePt = config.paymentConfig.paymentTypes.length == 1;
        const preAddAccount = accountNumber && (paymentTypeCode || isOnePt);
        let header = data.payments[0].header;
        header.paymentTypeCode = paymentTypeCode || header.paymentTypeCode;
        header.paymentAmount = paymentAmount || header.paymentAmount;
        header.accountNumber = accountNumber || header.accountNumber;
        header.authToken1 = authToken1 || '';
        header.authToken2 = authToken2 || '';
        header.authToken3 = authToken3 || '';
        header.externalReferenceNumber = externalReferenceNumber || '';
        header.preAddAccount = preAddAccount || false;
    } else {
        data.customer.email = prepopulatedData.customer.email;
        prepopulatedData.accounts.forEach((account)=>{
            let newPayment = createNewPayment(data, config)
            newPayment.accountInfoResponse = account
            if(account.accountNumber) newPayment.header.accountNumber = account.accountNumber;
            if(account.paymentTypeCode) newPayment.header.paymentTypeCode = account.paymentTypeCode;
            if(account.authToken1) newPayment.header.authToken1 = account.authToken1;
            if(prepopulatedData.selectedAccountNumbers && (prepopulatedData.selectedAccountNumbers.indexOf(account.accountNumber) !== -1)) {
                newPayment.preSelected = true
            }
            data.payments.push(newPayment)
        })
        if(prepopulatedData.selectedAccountNumbers && prepopulatedData.selectedAccountNumbers.length > 0) data.hideNonSelectedAccounts = true
    }

    if(prepopulatedData && prepopulatedData.profiles) data.currentUserWallet = prepopulatedData.profiles
    if (prepopulatedData && prepopulatedData.customer){
        data.currentCustomer = prepopulatedData.customer
    }

    data.cpDoNotSavePmEnabled = true

    delete config.prepopulatedData;

}

/**
 * set payment fields from itok
 * Used in ips (integrated payment service) app
 * @param data
 * @param config
 */
function prepopulatePayments(data, config) {
    const prepopulatedData = config.prepopulatedData;
    data.paymentData = JSON.parse(prepopulatedData.paymentData);

    const paymentComponents = data.paymentData.paymentComponents;

    // Iterate through items array from payment components and create new payment object in data
    if(prepopulatedData && paymentComponents){
        paymentComponents.forEach((pc, i) => {
            // A single empty payment object exists with the initial state, if payment object already exists
            // then simply utilize and set the field
            if (!data.payments[i]) {
                let newPayment = createNewPayment(data, config);
                let header = newPayment.header;
                header.accountNumber = pc.itemNumber;
                header.paymentTypeCode = 'UNLISTED';
                header.authToken1 = '';
                header.authToken2 = '';
                header.authToken3 = '';
                header.paymentAmount = pc.amountDue;
                header.effectiveDate = {dateStr: moment().format(JS_DATE_FORMAT)};
                newPayment.bundle = [];
                newPayment.bundle.push(pc);
                // newPayment.bundle.push(pc.items);
                data.payments.push(newPayment)
                data.payments.active = true;

            } else { // If there a multiple payment components, then we will create additional
                // payment objects and set the fields accordingly.
                data.payments[i].bundle = [];
                let header = data.payments[i].header;
                // Set Account number
                header.accountNumber = pc.itemNumber;
                header.paymentTypeCode = 'UNLISTED';
                header.authToken1 = '';
                header.authToken2 = '';
                header.authToken3 = '';
                header.paymentAmount = pc.amountDue;
                header.effectiveDate = {dateStr: moment().format(JS_DATE_FORMAT)};
                data.payments[i].bundle.push(pc);
                // data.payments[i].bundle.push(pc.items);
                data.payments[i].active = true;
            }
        })
    }

    data.totalPaymentAmount = data.paymentData.paymentTotalAmount;
    data.postBackUrl = data.paymentData.redirectUrl;
    data.customerState = data.paymentData.customerState;
    data.customer.email = prepopulatedData.email;

    delete config.prepopulatedData;
}

function removePayment(data, config, index) {
    let indexToRemove = data.payments.findIndex(p => p && p.index === index);
    if (indexToRemove >= 0) {
        data.payments.splice(indexToRemove, 1);
        if (data.nextNumber === 0) {
            // Create a blank payment, after removing the last one.
            data.payments.push(createNewPayment(data, config));
        }
    }
}

function resetPaymentMethod(data) {
    data.paymentMethod = { // whenever the payment method type changes, we update the convenience fee for each payment
        set type(val) {
            this.internalType = val;
            for (let i = 0; i < data.payments.length; i++) {
                let payment = data.payments[i];
                const paymentTypeId = payment.header.paymentTypeId;
                const paymentAmount = payment.header.paymentAmount;
                updateConvenienceFee(data, config, payment.index, paymentTypeId, paymentAmount);
            }
        },
        get type() {
            return this.internalType;
        }
    };
}

function resetCurrentUserWallet(data) {
    data.currentUserWallet = [];

    // also reset payment method if any wallet item was selected
    let {paymentMethodCategory = ""} = data.paymentMethod || {};
    if (isWalletPM(paymentMethodCategory)) {
        resetPaymentMethod(data);
    }
}

function resetPayments(data, config) {
    data.payments = [];
    data.totalPaymentAmount = 0;
    delete data.nextNumber;
    if(!config.prepopulatedData || !config.prepopulatedData.accounts) data.payments.push(createNewPayment(data, config));
}

function resetPaymentPreferences(data, config) {
    delete data.disasterRecovery;
    delete data.serviceCenterNumber;
    delete data.paymentResponse;
    delete data.fieldReceiptNumber;
    delete data.fieldReceiptDate;

}

const INITIAL_STATE = {
    customer: {address: {}},
    payments: [],
    paymentMethod: {},
    currentUserWallet: [],  // customer wallet
    totalPaymentAmount: 0,
    totalAmountDue: 0,
    globalErrors: []
};

/**
 * This method will reset data to its initial state.
 * @param data
 * @param config
 */
function resetData(data, config) {
    resetPayments(data, config);
    if (!config.useCardPresentDedicatedFlow) {
        data.paymentMethod = {};
        resetPaymentMethod(data);
    }
    data.currentUserWallet = [];
    data.customer = {address: {}};
    delete data.fieldReceipt;
    resetPaymentPreferences(data, config);
    delete data.showReceipt;
    delete data.preparedPayment;
    delete data.gaReceiptEventSent;
    data.globalErrors = [];
}

function updateConvenienceFee(data, config, paymentIndex, paymentTypeId, paymentAmount) {
    const paymentMethodConfigs = config.paymentConfig.paymentMethods;
    const paymentMethod = data.paymentMethod;
    let payment = data.payments.find(payment => payment.index === paymentIndex);
    if(payment) payment.header.convenienceFee = getConvenienceFee(paymentMethodConfigs, paymentMethod, paymentTypeId, paymentAmount);
}

// calculate the convenience fee based on paymentMethodType, paymentTypeId, paymentAmount
// Note: this function should be functionally the same as the getConvenienceFee in PaymentConfig.java
function getConvenienceFee(paymentMethodConfigs, paymentMethod, paymentTypeId, paymentAmount) {
    let paymentMethodConfig = null;
    const {type: paymentMethodType, paymentMethodCategory} = paymentMethod || {};
    if (!Array.isArray(paymentMethodConfigs)) {
        throw new Error('Convenience fee is not properly configured');
    }
    let category = paymentMethodCategory;

    if (/_IVR$/.test(paymentMethodCategory)) {
        category = paymentMethodCategory.substring(0, paymentMethodCategory.length - 4);
    }

    if (paymentMethodType) {
        // get the payment method config matching the payment method type
        paymentMethodConfig = paymentMethodConfigs.find(pm => pm.code === paymentMethodType);
    } else {
        // Staged IVR calculate based on category code only
        const pmList = paymentMethodConfigs.filter(pm => pm.categoryCode === category);
        // use the first in the list
        paymentMethodConfig = pmList[0];
    }

    if (!paymentMethodConfig || !paymentAmount) {
        return 0;
    }
    // apply logic based on paymentAmount and paymentTypeId to obtain the correct convenience fee
    // Check if convenience fee is variable, if not we return the default convenience fee
    let convenienceFeeConfig;
    if (!isConvenienceFeeVariable(paymentMethodConfig)) {
        convenienceFeeConfig = getDefaultConvenienceFeeConfig(paymentMethodConfig, paymentTypeId);
    } else {
        convenienceFeeConfig = getConvenienceFeeConfig(paymentMethodConfig, paymentAmount, paymentTypeId);
    }
    // Get the convenience fee by amount
    return getConvenienceFeeForAmount(convenienceFeeConfig, paymentAmount);
}

function getConvenienceFeeForAmount(convenienceFeeConfig, paymentAmount) {
    let amount = 0;
    // If the convenience fee is a percentage value
    if (convenienceFeeConfig.convenienceFeeTypeCode === "PERCENT") {
        let percent = convenienceFeeConfig.convenienceFee;
        if (percent > 0) {
            amount = paymentAmount * percent / 100;
            return convenienceFeeConfig.baseConvenienceFee ? round(convenienceFeeConfig.baseConvenienceFee + round(amount)) : round(amount);
        }
    }
    // otherwise just return the convenience fee
    return convenienceFeeConfig.convenienceFee;

}

function round(amount) {
    const factor = 100;
    amount = amount * factor;
    return Math.round(amount) / factor;
}

function isConvenienceFeeVariable(paymentMethodConfig) {
    return (paymentMethodConfig.cnvFeeConfigList && paymentMethodConfig.cnvFeeConfigList.length > 1);
}

function getDefaultConvenienceFeeConfig(paymentMethodConfig, paymentTypeId) {
    let convenienceFeeConfigList = paymentMethodConfig.cnvFeeConfigList;
    if (!convenienceFeeConfigList || !(convenienceFeeConfigList instanceof Array)) {
        throw new Error('Convenience fee is not properly configured');
    }
    let sz = convenienceFeeConfigList.length;
    if (sz === 1) {
        return convenienceFeeConfigList[0];
    }
    let rs;
    for (let i = 0; i < sz; i++) {
        let pmtId = convenienceFeeConfigList[i].paymentTypeId || 0;
        if (isDefaultConvenienceFeeConfig(convenienceFeeConfigList[i]) && pmtId === +paymentTypeId) {
            rs = convenienceFeeConfigList[i];
            break;
        }
    }
    if (rs) {
        return rs;
    }
    if (+paymentTypeId <= 0) {
        throw new Error('Convenience fee is not properly configured');
    }
    return getDefaultConvenienceFeeConfig(paymentMethodConfig, 0);
}

function getConvenienceFeeConfig(paymentMethodConfig, paymentAmount, paymentTypeId) {
    let convenienceFeeConfigList = paymentMethodConfig.cnvFeeConfigList;
    if (!convenienceFeeConfigList || !(convenienceFeeConfigList instanceof Array) || convenienceFeeConfigList.length < 1) {
        throw new Error('Convenience fee is not properly configured');
    }
    let sz = convenienceFeeConfigList.length;
    if (sz === 1) {
        return getDefaultConvenienceFeeConfig(paymentMethodConfig, paymentTypeId);
    }
    let rs;
    for (let i = 0; i < sz; i++) {
        let convenienceFeeConfig = convenienceFeeConfigList[i];
        let pmtId = convenienceFeeConfig.paymentTypeId || 0;
        if (isAmountInRange(convenienceFeeConfig, paymentAmount) && pmtId === +paymentTypeId) {
            rs = convenienceFeeConfig;
            break;
        }
    }

    if (rs) {
        return rs;
    }
    // Attempt to find generalized amount specific convenience fee
    for (let i = 0; i < sz; i++) {
        let convenienceFeeConfig = convenienceFeeConfigList[i];
        let pmtId = +convenienceFeeConfig.paymentTypeId;
        if (isAmountInRange(convenienceFeeConfig, paymentAmount) && pmtId <= 0) {
            rs = convenienceFeeConfig;
            break;
        }
    }

    return rs != null ? rs : getDefaultConvenienceFeeConfig(paymentMethodConfig, paymentTypeId);
}

function isAmountInRange(convenienceFeeConfig, amount) {
    return amount >= convenienceFeeConfig.amountFrom && amount <= convenienceFeeConfig.amountTo;
}

function isDefaultConvenienceFeeConfig(convenienceFeeConfig) {
    return convenienceFeeConfig.amountFrom <= 0.0 && convenienceFeeConfig.amountTo >= 0.0;
}

/**
 * Convert account info received from the REST API call into payment.
 * @param payment - payment object to update
 * @param data - account info received from the REST API
 * @param paymentConfig
 * @param customer
 */
function populatePayment(payment, data, paymentConfig, customer) {
    let liability = data || {};
    // xotp response uses dateDue, we will use dueDate
    if (data.dateDue) {
        liability.dueDate = moment(data.dateDue, 'MMDDYYYY').format(JS_DATE_FORMAT);
    }

    // If defaultPaymentTypeToLiability is set to true, and default payment type code/id exist
    // we overwrite the payment type setting with the payment type specified by the liability record
    if (paymentConfig && paymentConfig.defaultPaymentTypeToLiability) {
        if (liability.defaultPaymentTypeCode) {
            payment.header.paymentTypeCode = liability.defaultPaymentTypeCode;
        }
        if (liability.defaultPaymentTypeId) {
            payment.header.paymentTypeId = liability.defaultPaymentTypeId;
        }
    }

    payment.liability = liability;

    // initialize payment amount in header
    payment.header.paymentAmount = (liability && liability.amountDue > 0) ? liability.amountDue : 0.00;

    // set effective date now
    payment.header.effectiveDate = {
        dateStr: moment().format(JS_DATE_FORMAT)
    };

    let recentPayments = data.recentPayment || [];
    // The REST API returns an payment object, if there is a single payment not an array
    // Convert here to handle consistently.
    recentPayments = !Array.isArray(recentPayments) ? [recentPayments] : recentPayments;
    for (let i = 0; i < recentPayments.length; i++) {
        let pm = recentPayments[i].paymentMethod || {};
        // split payment method account number into 2 fields
        let accountNumber = pm.accountNumber;
        if (accountNumber) {
            if (accountNumber.indexOf("-") > -1) {
                let maskedAccountNumber = accountNumber.substring(accountNumber.indexOf("-") + 1);
                let maskedRoutingNumber = accountNumber.substring(0, accountNumber.indexOf("-"));
                pm.maskedAccountNumber = maskedAccountNumber;
                pm.maskedRoutingNumber = maskedRoutingNumber;
            } else {
                pm.maskedAccountNumber = accountNumber;
            }
        }
    }
    payment.recentPayments = recentPayments;
    // check for last used pm
    let lastUsedPm = data.lastUsedPm;
    if (lastUsedPm) {
        let accountNumber = lastUsedPm.accountNumber;
        if (accountNumber) {
            if (accountNumber.indexOf("-") > -1) {
                let maskedAccountNumber = accountNumber.substring(accountNumber.indexOf("-") + 1);
                let maskedRoutingNumber = accountNumber.substring(0, accountNumber.indexOf("-"));
                lastUsedPm.maskedAccountNumber = maskedAccountNumber;
                lastUsedPm.maskedRoutingNumber = maskedRoutingNumber;
            } else {
                lastUsedPm.maskedAccountNumber = accountNumber;
            }
        }
    }
    payment.lastUsedPm = lastUsedPm;

    if (customer && liability.customer) {
        const liabCustomer = liability.customer;
        // pre-populate first/last name, only the first time
        if (!customer.firstName && !customer.lastName && !customer.middleName) {
            customer.firstName = liabCustomer.firstName || '';
            customer.lastName = liabCustomer.lastName || '';
            customer.middleName = liabCustomer.middleName || '';
        }
        if (!customer.email){
            customer.email = liabCustomer.email || '';
        } 
        if (!customer.email2){
            customer.email2 = liabCustomer.email || '';
        } 
        if(!customer.dayPhone){
            customer.dayPhoneNr = liabCustomer.dayPhone || '';
        } 
        if(!customer.address.zip) {
            customer.address.zipCode = liabCustomer.address.zipCode || '';
        }
    }
}

/**
 * FIXME: Alfa specific function
 * - initialize the selected flag to precheck the checkbox
 * - initialize checked radio option based on isDefault flag from rt response
 * - update payment amounts
 * @param payment
 * @param data
 */
function selectAllPaymentGroupsToPay(payment, data) {
    payment.bundle.forEach(group => {
        group.selected = true;
        if (group.isPayable) {
            initializeSelectedGroup(group);
        }
    });
    updateTotals(data);
}


/**
 * FIXME: Alfa specific function
 * - check the "item Number" is duplicate or not
 * - update payment amounts
 * @param group
 * @param data
 */
function duplicateRemove(group,data){
    let count = 0;
    const itemNumber = group.itemNumber;
    const payments = data.payments;
    for (var index in payments){
        if (payments[index].bundle){
            //go inside check duplicate if and only if the payment.bundle is not null
            if(itemNumber == payments[index].bundle[0].itemNumber && payments[index].bundle[0].selected){
                count+=1;
            }
        }
        else{
            //if the payment.bundle is null, it will report error, this else block avoid that error.
            continue;
        }
        if(count>1){
            group.selected = false;
            data.payments = data.payments.filter((payment) => (payment.bundle[0].itemNumber !== itemNumber || (payment.bundle[0].itemNumber == itemNumber &&!payment.bundle[0].selected)));
            count -=1;
            return messages["opp.validation.acct.duplicate"];
        }
    }
}
/**
 * FIXME: Alfa specific function
 * - initialize checked radio option based on isDefault flag from rt response
 * @param group
 */
function initializeSelectedGroup(group) {
    const {items} = group;
    // 1. preselect an amount option for each payable item
    // 2. initialize the payment amount based on the preselected amount option
    items.forEach(item => {
        if (item.amounts && item.amounts.length > 0) {
            let amountPreSelected = item.amounts.find(item => item.isDefault);
            if (!amountPreSelected) {
                // If there is non one marked isDefault, pick the first.
                // When item.isRequired we don't have None
                // When !item.isRequired the first item is None.
                amountPreSelected = item.amounts[0];
            }

            item.selectedAmountOption = `${amountPreSelected.index}`;
            item.paymentAmount = (item.pacSelected) ? amountPreSelected.amount : amountPreSelected.pacAdjustedAmount;
            item.selectedAmountOptionName = amountPreSelected.name;
        }
    });
}

// FIXME: Alfa specific function
function updateTotals(data) {
    let totalPaymentAmount = 0;
    let totalConvFee = 0;
    data.payments.forEach(payment => {
        let paymentAmount = 0;
        let feeAmount = 0;
        if (payment.bundle) {
            if(payment.bundle.paymentItems){
                let totalItemPaymentAmount = 0;
                if(payment.bundle.paymentItems.length > 0){
                payment.bundle.paymentItems.forEach(item =>{
                    if (item.selected && item.paymentAmount) {
                        totalItemPaymentAmount =  round(totalItemPaymentAmount + round(item.paymentAmount));
                    }
                });
            }else{
                if (payment.bundle.paymentItems.selected && payment.bundle.paymentItems.paymentAmount) {
                    totalItemPaymentAmount =  round(totalItemPaymentAmount + round(payment.bundle.paymentItems.paymentAmount));
                }
            }
                paymentAmount = round(totalItemPaymentAmount);
            }else{
                payment.bundle.forEach(group => {
                    let groupAmount = 0;
                    group.items.forEach(item => {
                        if (item.paymentAmount) {
                            groupAmount = round(groupAmount + round(item.paymentAmount));
                        }
                    });
                    group.paymentAmount = groupAmount;
                    paymentAmount = round(paymentAmount + groupAmount);
                });
            }
            payment.header.paymentAmount = paymentAmount;
        } else {
            paymentAmount = round(payment.header.paymentAmount);
            feeAmount = round(payment.header.convenienceFee);
        }
        totalPaymentAmount = round(totalPaymentAmount + paymentAmount);
        totalConvFee = round(totalConvFee + feeAmount);
    });
    data.totalPaymentAmount = round(totalPaymentAmount + totalConvFee);
    data.totalConvFee = totalConvFee;
}

function updateConvFee() {

}

/**
 * This map maps error key prefixes from xotp to a field name
 * in the page.
 */
const errorToFieldMap = {
    "paymentTypeCode": "header.paymentTypeCode",
    "liabilityRecord": "header.accountNumber",
    "accountNumber": "header.accountNumber",
    "authToken1": "header.authToken1",
    "authToken2": "header.authToken2",
    "authToken3": "header.authToken3",
    "firstName": "customer.firstName",
    "lastName": "customer.lastName",
    "middleName": "customer.middleName",
    "addressZipCode": "customer.address.zipCode",
    "addressLine1": "customer.address.line1",
    "addressLine2": "customer.address.line2",
    "addressCity": "customer.address.city",
    "addressState": "customer.address.state",
    "dayPhone": "customer.dayPhone.text",
    "email": "customer.email",
    "email2": "customer.email2",
    "paymentAmount": "header.paymentAmount",
    "paymentDate": "header.effectiveDate.dateStr",
    "pmBankAccount": "paymentMethod.accountNumber",
    "pmRoutingNumber": "paymentMethod.routingNumber",
    "pmBankAccountHolderName": "paymentMethod.cardHolderName",
    "pmBankName": "paymentMethod.fiName",
    "paymentMethodType": "paymentMethod.type",
    "pmExpiryDate": "paymentMethod.creditCardExpiryDate",
    "pmCardHolderName": "paymentMethod.cardHolderName"
};

function pmTypeRequiresAccountNumber(pmType) {
    return isCreditCardCat(pmType) || isDebitCardCat(pmType)
        || isDirectDebitCat(pmType) || isPinlessDebitCat(pmType)
        || isCardPresentCat(pmType);
}

function cashRequiresCheckNumber(pmType) {
    return isCheck(pmType);
}

function cashRequiresName(pmType) {
    return isCheck(pmType);
}

/**
 * Returns true whenever pmType matches:
 *   WALLET-1
 *   WALLET-2
 *   WALLET-5
 *   ...
 *
 * @param pmType
 * @return {boolean}
 */
function isWalletPM(pmType) {
    return /^WALLET-[0-9]+$/.test(pmType);
}

function isCreditCardCat(pmType) {
    return pmType === 'VISA' || pmType === 'MC' ||
        pmType === 'AMEX' || pmType === 'DISC';
}

function isDebitCardCat(pmType) {
    return pmType === 'VISA_DEBIT' || pmType === 'MC_DEBIT'
        || pmType === 'DISC_DEBIT';
}

function isCardPresentCat(pmCategory) {
    return pmCategory === 'CP_POS';
}

function isDirectDebitCat(pmType) {
    return pmType === 'CHQ' || pmType === 'SAV'
        || pmType === 'BUS_CHQ';
}

function isPinlessDebitCat(pmType) {
    return pmType === 'PD';
}

function isCashCat(pmType) {
    return pmType === 'WALKIN_CASH' || isCheck(pmType);
}

function isCash(pmType) {
    return pmType === 'WALKIN_CASH';
}

function isCheck(pmType) {
    return pmType === 'WALKIN_CHQ' || pmType === 'CASHIER_CHECK_CASH'
        || pmType === 'MONEY_ORDER_CASH';
}

function preparePaymentMethod(paymentMethod) {
    let {paymentMethodCategory, type} = paymentMethod;
    let pm = {};

    if (paymentMethodCategory === "CC" || paymentMethodCategory === "DC") {
        const {creditCardExpiryDate} = paymentMethod;
        pm = {
            type: type,
            "account-number": paymentMethod.accountNumber,
            "credit-card-expiry-date": {
                month: (creditCardExpiryDate || '').split("/")[0],
                year: "20" + (creditCardExpiryDate || '').split("/")[1]
            },
            cvv: paymentMethod.cvv,
            "card-holder-name": paymentMethod.cardHolderName,
        };
    } else if (paymentMethodCategory === "DD") {
        pm = {
            type: type,
            "routing-number": paymentMethod.routingNumber,
            "account-number": paymentMethod.accountNumber,
            "fi-name": paymentMethod.fiName,
            "card-holder-name": paymentMethod.cardHolderName
        };
    } else if (paymentMethodCategory === 'PD') {
        pm = {
            type: type,
            "account-number": paymentMethod.accountNumber,
            "card-holder-name": paymentMethod.cardHolderName
        };
    } else if (isWalletPM(paymentMethodCategory)) {
        pm = {
            token: paymentMethod.token
        };
        paymentMethodCategory = paymentMethod.walletCategory
    } else if (paymentMethodCategory === 'LAST_USED_PM') {
        // FIXME: add last used payment method here
    } else if (paymentMethodCategory && paymentMethodCategory.endsWith(STAGED_PM_CATEGORY_SUFFIX)) {
        console.log(`Stripping suffix from staged payment method category: ${paymentMethodCategory}`);
        paymentMethodCategory = paymentMethodCategory.substring(0, paymentMethodCategory.indexOf(STAGED_PM_CATEGORY_SUFFIX));
    } else if (paymentMethodCategory === 'CASH') {
        pm = {
            type: type
        };
        if (cashRequiresCheckNumber(type)) {
            pm["check-number"] = paymentMethod.checkNumber;
        }
        if (cashRequiresName(type)) {
            pm["card-holder-name"] = paymentMethod.cardHolderName;
        }
    } else if (paymentMethodCategory === 'CP_POS') {
        pm = {
            type: type,
            "account-number": paymentMethod.accountNumber,
            "card-present-manual-entry": paymentMethod.cardPresentManualEntry,
            "card-present-terminal-hsn": paymentMethod.cardPresentTerminalHSN
        };
    } else {
        console.log(`Unknown payment method category: ${paymentMethodCategory}`);
    }

    pm["save-for-reuse"] = !!paymentMethod.saveForReuse;
    return {pm, paymentMethodCategory};
}

/**
 * Constructs a payment json object that can be passed to rest XOTP to make a payment.
 * FIXME: This submits a single payment !!!
 * @param data
 * @param config
 * @returns payment json object
 */
function preparePaymentForSubmission(data, config) {
    const {payments, customer, paymentMethod} = data,
        { address={} } = customer || {},
        firstPayment = payments[0],
        firstHeader = firstPayment.header,
        agentCenter = config.agentCenter;

    const {paymentConfig, messages} = config,
        {liabilityToken1Config, liabilityToken2Config, liabilityToken3Config} = paymentConfig;

    let {pm, paymentMethodCategory} = preparePaymentMethod(paymentMethod);
    let ivrLanguagePreference = '';
    if(paymentMethod.ivrLanguagePreference){
        ivrLanguagePreference =  paymentMethod.ivrLanguagePreference;                              
    }
    let paymentBundleItem = [];
    if(firstPayment.bundle && firstPayment.bundle.paymentItems){
        if(firstPayment.bundle.paymentItems.length > 0){
            firstPayment.bundle.paymentItems.forEach(item =>{
                if(item.selected){
                    let itemJson = {
                        "code":item.code,
                        "amount":item.paymentAmount
                    }
                    paymentBundleItem.push(itemJson);
                }
            });
        }else{
            let item = firstPayment.bundle.paymentItems;
            if(item.selected){
                let itemJson = {
                    "code":item.code,
                    "amount":item.paymentAmount
                }
                paymentBundleItem.push(itemJson);
            }
        }
    }

    const today = moment();
    const paymentDate = moment(firstHeader.effectiveDate.dateStr, 'MMDDYYYY');

    customer.address = customer.address || {};
    if (liabilityToken1Config === 'ZIP') {
        address["zipCode"] = firstHeader.authToken1;
    } else if (liabilityToken2Config === 'ZIP') {
        address["zipCode"] = firstHeader.authToken2;
    } else if (liabilityToken3Config === 'ZIP') {
        address["zipCode"] = firstHeader.authToken3;
    }
    if(paymentBundleItem.length > 0 ){
        return    {
            payment: {
                bundle :{
                    "payment-item":paymentBundleItem,
                },
        
                user: {
                    "login-id": config.agentLoginId
                },
                header: {
                    "agent-id": config.agentUserId,
                    "agent-group-id": config.agentGroupId,
                    "agent-group-description": config.agentGroupDescription,
                    "agent-center": agentCenter,
                    "operation": "SALE",
                    "account-number": firstHeader.accountNumber,
                    "auth-token1": firstHeader.authToken1,
                    "auth-token2": firstHeader.authToken2,
                    "auth-token3": firstHeader.authToken3,
                    "external-reference-number": firstHeader.externalReferenceNumber,
                    "payment-type-code": firstHeader.paymentTypeCode,
                    "payment-amount": firstHeader.paymentAmount.toFixed(2),
                    "convenience-fee": firstHeader.convenienceFee.toFixed(2),
                    "convenience-fee-state": firstHeader.convenienceFeeState,
                    "convenience-fee-country": firstHeader.convenienceFeeCountry,
                    "channel-code": config.channelCode,
                    "contact-email": customer.email,
                    "application-code": config.appCode,
                    "check-duplicates": "false",
                    "language-preference": ivrLanguagePreference,
                    "effective-date": {
                        // Submit future dated, for real time send empty
                        "date-str": paymentDate.isAfter(today)
                            ? paymentDate.format('MMDDYYYY')
                            : ''
                    },
                    "do-callback": paymentMethod.doCallback,
                    "callback": {
                        "text": paymentMethod.callbackNumber,
                        "ext": paymentMethod.callbackNumberExt
                    },
                    "cash-tendered": isCash(paymentMethod.type) && paymentMethod.cashTendered
                                    ? paymentMethod.cashTendered.toFixed(2)
                                    : 0
                }, 
                customer: {
                    "email": customer.email,
                    "first-name": customer.firstName,
                    "last-name": customer.lastName,
                    "middle-name": customer.middleName,
                    "day-phone-nr": customer.dayPhoneNr,
                    "day-phone-ext": customer.dayPhoneExt,
                    address: {
                        "zip-code": address.zipCode,
                        "line1": address.line1,
                        "line2": address.line2,
                        "city": address.city,
                        "state": address.state
                    }
                },
                "payment-method-category": paymentMethodCategory,
                "payment-method": pm
            }
        };
    }else {
    return {
        payment: {
    
            user: {
                "login-id": config.agentLoginId
            },
            header: {
                "agent-id": config.agentUserId,
                "agent-group-id": config.agentGroupId,
                "agent-group-description": config.agentGroupDescription,
                "agent-center": agentCenter,
                "operation": "SALE",
                "account-number": firstHeader.accountNumber,
                "auth-token1": firstHeader.authToken1,
                "auth-token2": firstHeader.authToken2,
                "auth-token3": firstHeader.authToken3,
                "external-reference-number": firstHeader.externalReferenceNumber,
                "payment-type-code": firstHeader.paymentTypeCode,
                "payment-amount": firstHeader.paymentAmount.toFixed(2),
                "convenience-fee": firstHeader.convenienceFee.toFixed(2),
                "convenience-fee-state": firstHeader.convenienceFeeState,
                "convenience-fee-country": firstHeader.convenienceFeeCountry,
                "channel-code": config.channelCode,
                "contact-email": customer.email,
                "application-code": config.appCode,
                "language-preference": ivrLanguagePreference,
                "check-duplicates": "false",
                "effective-date": {
                    // Submit future dated, for real time send empty
                    "date-str": paymentDate.isAfter(today)
                        ? paymentDate.format('MMDDYYYY')
                        : ''
                },
                "do-callback": paymentMethod.doCallback,
                "callback": {
                    "text": paymentMethod.callbackNumber,
                    "ext": paymentMethod.callbackNumberExt
                },
                "cash-tendered": isCash(paymentMethod.type) && paymentMethod.cashTendered
                                ? paymentMethod.cashTendered.toFixed(2)
                                : 0
            }, 
            customer: {
                "email": customer.email,
                "first-name": customer.firstName,
                "last-name": customer.lastName,
                "middle-name": customer.middleName,
                "day-phone-nr": customer.dayPhoneNr,
                "day-phone-ext": customer.dayPhoneExt,
                address: {
                    "zip-code": address.zipCode,
                    "line1": address.line1,
                    "line2": address.line2,
                    "city": address.city,
                    "state": address.state
                }
            },
            "external-data" : firstPayment.externalData,
            "payment-method-category": paymentMethodCategory,
            "payment-method": pm
        }
    };
}
}

// currency formatter
const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
});

/**
 * Returns a formatted currency string for the given amount
 * @param amount
 * @returns {string}
 */
function formatAmount(amount) {
    return formatter.format(amount || 0);
}

/**
 * If we get unauthorized response from an ajax call it most likely
 * the session has expired, forwawrd to invalid session page
 */
function handleUnauthorizedRequest() {
    window.location.href = 'session-invalid.do';
}

function mapAccountInfoErrors(errors, fieldPrefix) {
    // map backend errors to fields in the UI
    const errorList = !Array.isArray(errors) ? [errors] : errors;
    return errorList.reduce((ac, error) => {
        const {key, value} = error;
        const keyPrefix = key.substring(0, key.indexOf('.'));
        const fieldName = `${fieldPrefix}.${errorToFieldMap[keyPrefix]}`;
        ac[fieldName] = value;
        return ac;
    }, {});
}

/**
 * Convert validation errors returned by XOTP REST API into validation errors
 * that can be shown on the form.
 * @param errors - Array{{code: String, value: String}}
 * @param errorToFieldMap - Map for error keys
 * @param fields - registered field map
 * @returns {{globalErrors: Array, mappedErrors: Object}}
 */
function convertSubmitErrors(errors, errorToFieldMap, fields) {
    let globalErrors = [];
    let mappedErrors = {};
    errors = !Array.isArray(errors) ? [errors] : errors;
    for (let error of errors) {
        const {key, value} = error;
        const keyPrefix = (key || '').substring(0, key.indexOf('.'));
        const fieldName = errorToFieldMap[keyPrefix];
        const field = fields[fieldName];
        if (!fieldName || !field || field.registered === false) {
            // if error was not mapped to a visible field, put it in the
            // global error list
            globalErrors.push({
                code: key,
                message: value
            });
        } else {
            mappedErrors[fieldName] = value;
        }
    }
    return {globalErrors, mappedErrors};
}

/**
 * generates a UUID
 * @returns {uuid}
 */
function generateUUID(){
    return uuid();
}

/**
 * Generic post payment process method
 * By default only triggers show receipt page
 */
function postProcessSuccessfulPayment(res, req, state) {
    const {config, setValue} = state;
    setValue('showReceipt', true);
}

/**
 * Method to format account number. No format to be applied by default.
 */
function formatAccountNumber (accountNumber, paymentType, clientConfig) {
    return accountNumber;
}

export {
    createNewPayment,
    preparePaymentMethod,
    prepopulatePartialPayment,
    prepopulatePayments,
    removePayment,
    resetPayments,
    resetData,
    resetPaymentMethod,
    resetCurrentUserWallet,
    updateConvenienceFee,
    populatePayment,
    selectAllPaymentGroupsToPay,
    duplicateRemove,
    initializeSelectedGroup,
    updateTotals,
    errorToFieldMap,
    mapAccountInfoErrors,
    pmTypeRequiresAccountNumber,
    cashRequiresCheckNumber,
    cashRequiresName,
    isCheck,
    isCash,
    isWalletPM,
    INITIAL_STATE,
    preparePaymentForSubmission,
    postProcessSuccessfulPayment,
    formatAmount,
    isDirectDebitCat,
    isCreditCardCat,
    isDebitCardCat,
    isCardPresentCat,
    handleUnauthorizedRequest,
    updateConvFee,
    round,
    convertSubmitErrors,
    generateUUID,
    formatAccountNumber
};